import { Policy } from '@commandDrivenStateEngine/core/policies';
import { NavbarState } from '../state';
import { NavbarCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
/**
 * App Login QR Policy
 *
 * Responsibilities:
 * - React when QR modal opens
 * - Fetch QR code from backend
 * - Update state with QR image or error
 */
export const createAppLoginQRPolicy = (
  backend: ClientLibraryType
): Policy<NavbarState, NavbarCommand> => ({
  name: 'navbar-app-login-qr',

  shouldReact: ( prev, next ) => {
    // React when QR modal opens and we don't have an image yet
    return (
      !prev.appLoginQRModal.isOpen &&
      next.appLoginQRModal.isOpen &&
      !next.appLoginQRModal.qrCodeImage
    );
  },

  onStateChange: async ({ ctx }) => {
    const { dispatch } = ctx;

    // Set loading state
    dispatch(
      { type: 'navbar/qrModal/setLoading', payload: { isLoading: true }},
      { source: 'api' }
    );

    try {
      const response = await backend.get.generate_app_login_url();

      dispatch(
        {
          type: 'navbar/qrModal/setImage',
          payload: { image: response?.image || null }
        },
        { source: 'api' }
      );
    } catch ( error ) {
      console.error( '[navbar] Error generating QR code:', error );

      dispatch(
        { type: 'navbar/qrModal/setImage', payload: { image: null }},
        { source: 'api' }
      );
    }
  }
});
